import type { ReactNode } from 'react';
import { IndexerChartCard } from '../IndexerChartCard';
import type { ChartGuideKey } from '../../lib/chart-guides';

export function PageChartsPanel({
  title,
  subtitle,
  guideKey,
  children,
}: {
  title: string;
  subtitle?: string;
  guideKey?: ChartGuideKey;
  children: ReactNode;
}) {
  return (
    <IndexerChartCard
      className="mt-1 mb-0"
      title={title}
      subtitle={subtitle}
      guideKey={guideKey}
      bodyClassName="p-3"
    >
      {children}
    </IndexerChartCard>
  );
}
